import React, { useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import './SidebarLayout.css';
import logo from './logo.png';
import { useTheme } from './ThemeContext';
import AuthContext from './AuthContext';
import PermissionGuard from "./PermissionGuard";
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const menuItems = [
  { to: "/employee-dashboard", label: "Employee Dashboard", icon: "", permission: "view_dashboard" },
  { to: "/dashboard",             label: "Rx AI",    icon: "", permission: "view_hospital_dashboard" },
  { to: "/gp-rx-dashboard",             label: "GPRx AI",    icon: "", permission: "view_dashboard" },
  { to: "/ex-fac-dashboard",      label: "Ex Fac AI",    icon: "", permission: "view_exfac_dashboard" },
  { to: "/internal-reports-configuration", label: "Data Configuration", icon: "", permission: "view_internal_reports_configuration" },
  { to: "/internal-reports",      label: "Internal Reports",    icon: "", permission: "view_internal_reports" },
  { to: "/admin", label: "Admin", icon: "", permission: "view_admin" },
];

function SidebarLayout({ children }) {
  const { theme } = useTheme();
  const { user, logout } = useContext(AuthContext);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  const renderMenu = () => (
    <ul className="menu-list" role="menu" aria-label="Primary">
      {menuItems.map(({ to, label, icon, permission }) => (
        <PermissionGuard key={to} permission={permission}>
          <li role="none">
            <NavLink to={to} onClick={isSidebarOpen ? toggleSidebar : undefined} role="menuitem">
              <span className="sidebar-icon" aria-hidden="true">{icon}</span>
              <span className="sidebar-text">{label}</span>
            </NavLink>
          </li>
        </PermissionGuard>
      ))}
    </ul>
  );

  return (
    <div className={`sidebar-layout ${theme}`}>
      {/* Mobile Header */}
      <div className="mobile-header">
        <IconButton
          onClick={toggleSidebar}
          aria-label="Open sidebar"
          sx={{
            backgroundColor: '#00BFA5',
            color: 'white',
            width: 44, height: 44, borderRadius: '50%',
            boxShadow: '0 6px 18px rgba(0,0,0,0.25)',
            zIndex: 1002,
            display: 'flex', justifyContent: 'center', alignItems: 'center'
          }}
        >
          <MenuIcon />
        </IconButton>
        <img src={logo} alt="Company Logo" className="header-logo" />
      </div>

      {/* Desktop Sidebar */}
      <aside className="sidebar" aria-label="Sidebar">
        <div className="sidebar-logo">
          <img src={logo} alt="Company Logo" />
        </div>
        {user && (
          <div className="sidebar-welcome">
            <p>Welcome, <span>{user.username}</span></p>
          </div>
        )}
        <nav className="sidebar-menu">{renderMenu()}</nav>
        <div className="sidebar-footer">
          <button className="btn-logout" onClick={logout} aria-label="Logout">Logout</button>
        </div>
      </aside>

      {/* Mobile Slide-out Menu */}
      <div className={`sidebar-slide-wrapper ${isSidebarOpen ? 'open' : ''}`} aria-hidden={!isSidebarOpen}>
        <nav className="sidebar-menu">{renderMenu()}</nav>
        <div className="sidebar-footer">
          <button className="btn-logout" onClick={logout} aria-label="Logout">Logout</button>
        </div>
      </div>

      {/* Overlay */}
      {isSidebarOpen && <div className="overlay" onClick={toggleSidebar} />}

      {/* Main Content */}
      <main className="main-content">{children}</main>
    </div>
  );
}

export default SidebarLayout;
